(ns dashboard.views.organization.controller
  (:require [dashboard.entity.analysis.db :as analysis.db]
            [dashboard.entity.organization.db :as org.db]
            [dashboard.services.questionnaire-list :as questionnaire-list]
            [re-frame.core :as rf]))
;; ----------------------------------------------------------------------------
;;  Controller & Routing
;; ----------------------------------------------------------------------------

(def controllers
  [{:parameters {:path [:selected-person-id
                        :action]}
    :start (fn [{:keys [path]}]
             (org.db/fetch-organization)
             (when (= "history" (:action path))
               (org.db/fetch-person-revision-history))
             (when (= "responsibilities" (:action path))
               (org.db/fetch-person-asa-responsibilities))
             (org.db/clear-form-errors)
             (analysis.db/get-structured-analyses true)
             (analysis.db/get-applied-analyses true)
             (analysis.db/get-structured-analysis-questions true)
             (analysis.db/get-categories true)
             (rf/dispatch [::questionnaire-list/get {:template true} nil true]))}])
